import script from "./DoctorProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorProfile.vue?vue&type=script&setup=true&lang=js"

import "./DoctorProfile.vue?vue&type=style&index=0&id=7fb6e5aa&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb6e5aa"]])

export default __exports__